module.exports = __webpack_public_path__ + "img/no_image.4e3c3d9.svg";